import './download';
import './frontParticle'
import './header';

import Menu from './burger';
const menu = new Menu('.burgerButton', '.burgerContainer');
